import Home from "./Pages/Home.js"


const homeScreen = new Home(document.querySelector("canvas.screenWebgl"))